import moment from 'moment-timezone';

export const getMailItemDuration = (
  sentAt,
  userTimezone,
  isSchedule = false,
) => {
  const currentDate = moment(new Date());
  const emailSentDate = moment(sentAt);

  if (emailSentDate) {
    const fullDate = `${
      isSchedule ? 'Scheduled on' : ''
    } ${emailSentDate.format('MMM DD')}, ${emailSentDate?.format(
      'YYYY',
    )}, at ${emailSentDate
      ?.format('hh:mm a')
      .toUpperCase()} (GMT${emailSentDate
      ?.tz(userTimezone)
      ?.format('Z')}) ${userTimezone}`;

    const diffInYear = currentDate.diff(emailSentDate, 'years');

    if (diffInYear > 0) {
      return {
        displayDate: emailSentDate.format('DD MMM, YYYY'),
        fullDate,
      };
    }

    return {
      displayDate:
        isSchedule && emailSentDate.isSame(currentDate, 'day')
          ? emailSentDate.format('hh:mm A')
          : emailSentDate.format('MMM Do'),
      fullDate,
    };
  }
  return {
    displayDate: '',
    fullDate: '',
  };
};

export const getDateTimeAsPerUserTimezone = (
  sentAt,
  userTimezone,
  isSchedule = false,
) => {
  const currentDate = moment(new Date());
  const emailSentDate = moment(sentAt);

  if (emailSentDate) {
    // Convert to user's timezone if provided, otherwise use original date
    const dateInUserTimezone = userTimezone
      ? emailSentDate.tz(userTimezone)
      : emailSentDate;

    const fullDate = `${
      isSchedule ? 'Scheduled on' : ''
    } ${dateInUserTimezone.format('MMM DD')}, ${dateInUserTimezone?.format(
      'YYYY',
    )}, at ${dateInUserTimezone
      ?.format('hh:mm a')
      .toUpperCase()} (GMT${dateInUserTimezone?.format('Z')}) ${
      userTimezone || 'UTC'
    }`;

    const diffInYear = currentDate.diff(emailSentDate, 'years');

    if (diffInYear > 0) {
      return {
        displayDate: dateInUserTimezone.format('DD MMM, YYYY'),
        fullDate,
      };
    }

    return {
      displayDate:
        isSchedule && emailSentDate.isSame(currentDate, 'day')
          ? dateInUserTimezone.format('hh:mm A')
          : dateInUserTimezone.format('MMM Do'),
      fullDate,
    };
  }
  return {
    displayDate: '',
    fullDate: '',
  };
};
